/* eslint-disable import/prefer-default-export */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
// import ReactDOM from 'react-dom';
import Store from './src/store';

export const wrapRootElement = Store;

// export const onInitialClientRender = () => {
//   setTimeout(() => {
//     document.getElementById('___loader').style.display = 'none';
//     document.body.style = null;
//   }, 1000);
// };

export const onRouteUpdateDelayed = ({ location, action }) => {
  document.getElementById('___loader').style.display = 'flex';
};

export const onRouteUpdate = ({ location, action }) => {
  setTimeout(() => {
    document.getElementById('___loader').style.display = 'none';
    document.body.style = null;
  }, 1000);
};

// export const onPrefetchPathname = ({ pathname }) => {
//   console.log('pathname', pathname);
// };

// export function replaceHydrateFunction() {
//   return (element, container, callback) => {
//     ReactDOM.render(element, container, callback);
//   };
// }
